import { services } from '../services';
var action = "transfer/booking";

export const bookingtransferService = {
    getList,
    getOne,
    insert,
    update,
    remove,
    getReceipt,
    approve,
    denie

};

function getList(param = '') {
    return services.restApi(`${action}${param}`, 'GET');
}

function getOne(id) {
    return services.restApi(`${action}/${id}`, 'GET');
}

function insert(object) {
    return services.restApi(`${action}`, 'POST', object);
}

function update(id, object) {
    return services.restApi(`${action}/${id}`, 'PUT', object);
}

function remove(id) {
    return services.restApi(`${action}/${id}`, 'DELETE');
}

function getReceipt(id) {
    return services.restApi(`${action}/receipt/${id}`, 'GET');
}

function approve(id) {
    return services.restApi(`${action}/approve/${id}`, 'POST');
}

function denie(id) {
    return services.restApi(`${action}/denie/${id}`, 'POST');
}